/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
 */
enum PebbleIcon {
  AccountCircle = "account_circle",
  Actions = "actions",
  AddFloors = "add-floors",
  Add = "add",
  AddedDetails = "added-details",
  Admin = "admin",
  AgreementLetter = "agreement-letter",
  AiCall = "ai-call",
  AlertFilled = "alert-filled",
  Alert = "alert",
  AllotmentLetter = "allotment-letter",
  Apps = "apps",
  ArrowBack = "arrow-back",
  ArrowDown = "arrow-down",
  ArrowDropDown = "arrow-drop-down",
  ArrowDropUp = "arrow-drop-up",
  ArrowRight = "arrow-right",
  ArrowUp = "arrow-up",
  Article = "article",
  Back = "back",
  Balcony = "balcony",
  BarGraph = "bar-graph",
  BasePrice = "base-price",
  Bathroom = "bathroom",
  Bedroom = "bedroom",
  Bolt = "bolt",
  BookmarkAdd = "bookmark-add",
  Building2 = "building-2",
  Building = "building",
  Business = "business",
  Calculate = "calculate",
  Calendar2 = "calendar-2",
  CalendarChecked = "calendar-checked",
  Calendar = "calendar",
  CallCenter = "call-center",
  Call = "call",
  Camera2 = "camera-2",
  Camera = "camera",
  CarFront = "car-front",
  Car = "car",
  ChangeNaming = "change-naming",
  ChannelPartners = "channel-partners",
  CheckBold = "check-bold",
  CheckCircleFilled = "check-circle-filled",
  Check = "check",
  CheckboxIndeterminate = "checkbox-indeterminate",
  CheckboxSelected = "checkbox-selected",
  CheckboxUnfilled = "checkbox-unfilled",
  CheckboxUnselected = "checkbox-unselected",
  CheckedServer = "checked-server",
  ChevronDown = "chevron-down",
  ChevronLeft = "chevron-left",
  Clipboard = "clipboard",
  ClockFilled = "clock-filled",
  Clock = "clock",
  CloseCircleFilled = "close-circle-filled",
  CloseCircle = "close-circle",
  Close = "close",
  CloudDownload = "cloud-download",
  CloudUploadFilled = "cloud-upload-filled",
  CloudUpload = "cloud-upload",
  Comment = "comment",
  ConfigureFloors = "configure-floors",
  ConfigureUnits = "configure-units",
  Contact = "contact",
  ControlUnit = "control-unit",
  CopyFilled = "copy-filled",
  Copy = "copy",
  CpIcon = "cp-icon",
  CrossChart = "cross-chart",
  Cross = "cross",
  Delete2 = "delete-2",
  DeleteFilled = "delete-filled",
  Delete = "delete",
  Description = "description",
  Dialer = "dialer",
  DigitalLeads = "digital-leads",
  DirectWalkins = "direct-walkins",
  DirectionCompass = "direction-compass",
  Direction = "direction",
  DocumentUploaded = "document-uploaded",
  Document = "document",
  DoorFront = "door-front",
  Dot = "dot",
  Dots = "dots",
  Download = "download",
  Edit2 = "edit-2",
  EditAlt = "edit-alt",
  EditDetails = "edit-details",
  EditNote = "edit-note",
  EditThin = "edit-thin",
  Edit = "edit",
  ExtraArea = "extra-area",
  EyeLine = "eye-line",
  Eye = "eye",
  FaceToFace2 = "face-to-face-2",
  FaceToFace3 = "face-to-face-3",
  FaceToFace = "face-to-face",
  Facing = "facing",
  FactCheck = "fact-check",
  File = "file",
  Filter2 = "filter-2",
  FilterAlt = "filter-alt",
  Filter = "filter",
  Fire = "fire",
  Firm = "firm",
  FlashOff = "flash-off",
  FlashOn = "flash-on",
  FolderZip = "folder-zip",
  Folder = "folder",
  FollowUp2Filled = "follow-up-2-filled",
  FollowUp2 = "follow-up-2",
  FollowUp = "follow-up",
  Forum = "forum",
  FullScreen = "full-screen",
  Funnel = "funnel",
  GradeLine = "grade-line",
  Grade = "grade",
  HamburgerBold = "hamburger-bold",
  Hamburger = "hamburger",
  HelpAndSupport = "help-and-support",
  Help = "help",
  Hidden = "hidden",
  History = "history",
  HomeFilled2 = "home-filled-2",
  HomeFilled = "home-filled",
  HomeWorkOutlined = "home-work-outlined",
  HomeWork = "home-work",
  Home = "home",
  HouseStatus = "house-status",
  HowToReg = "how-to-reg",
  Image = "image",
  IncomingCall2 = "incoming-call-2",
  IncomingCall = "incoming-call",
  IncomingCalls = "incoming-calls",
  InfoFilled = "info-filled",
  Info = "info",
  Inquiry = "inquiry",
  Inventory = "inventory",
  Invoice = "invoice",
  Jodi = "jodi",
  Junk = "junk",
  Landscape = "landscape",
  LeadsTab = "leads-tab",
  LineChart = "line-chart",
  Link = "link",
  List = "list",
  Location = "location",
  LockClock = "lock-clock",
  LockFilled = "lock-filled",
  LockOpen = "lock-open",
  Lock = "lock",
  LogoutDoor = "logout-door",
  Logout = "logout",
  MailSend = "mail-send",
  Mail = "mail",
  Mandates = "mandates",
  MeetingRoom = "meeting-room",
  Mic = "mic",
  Minus = "minus",
  MissedCall = "missed-call",
  Money = "money",
  More = "more",
  NotAvailable = "not-available",
  NotCalled = "not-called",
  Note1 = "note-1",
  NoteAlt = "note-alt",
  Note = "note",
  Notification = "notification",
  Offline = "offline",
  OpenExternal = "open-external",
  OpeningQuote = "opening-quote",
  Orientation = "orientation",
  OtherLeads = "other-leads",
  Others = "others",
  OutgoingCall2 = "outgoing-call-2",
  OutgoingCall = "outgoing-call",
  Patchout = "patchout",
  Pause = "pause",
  Pdf = "pdf",
  Percentage = "percentage",
  PersonAddDisabled = "person-add-disabled",
  PersonSearch = "person-search",
  PersonSquare = "person-square",
  Person = "person",
  Phone2 = "phone-2",
  PhoneAlt = "phone-alt",
  PhoneFilled = "phone-filled",
  PhoneInTalk = "phone-in-talk",
  PhoneIncoming2 = "phone-incoming-2",
  PhoneIncoming = "phone-incoming",
  PhoneMissed = "phone-missed",
  PhoneOutgoing2 = "phone-outgoing-2",
  PhoneOutgoing = "phone-outgoing",
  Phone = "phone",
  Play = "play",
  Plus = "plus",
  PossessionLetter = "possession-letter",
  Premium = "premium",
  Print = "print",
  PriorityChange = "priority-change",
  Profile1 = "profile-1",
  Profile = "profile",
  Quotations = "quotations",
  RadioCheckFilled = "radio-check-filled",
  RadioCheck = "radio-check",
  RadioSelected = "radio-selected",
  Radio = "radio",
  Redo = "redo",
  Reimbursements2 = "reimbursements-2",
  Reimbursements = "reimbursements",
  Reschedule = "reschedule",
  Reset = "reset",
  Revisit = "revisit",
  Rules = "rules",
  ScheduleMail = "schedule-mail",
  Search = "search",
  SelfAdded = "self-added",
  SendMessage = "send-message",
  SettingsLine = "settings-line",
  Settings = "settings",
  ShareWithPeople = "share-with-people",
  Share = "share",
  SiteVisit2 = "site-visit-2",
  SiteVisit = "site-visit",
  Sms = "sms",
  Spinner = "spinner",
  Stats2 = "stats-2",
  Stats = "stats",
  Store2 = "store-2",
  Store = "store",
  System = "system",
  Table = "table",
  Tag = "tag",
  Team = "team",
  Training = "training",
  Transfer2 = "transfer-2",
  TransferAlt = "transfer-alt",
  Transfer = "transfer",
  Transferred = "transferred",
  Travel = "travel",
  Trophy2 = "trophy-2",
  Trophy = "trophy",
  UncheckedRadio = "unchecked-radio",
  Undo = "undo",
  Unlock = "unlock",
  Update = "update",
  Updating = "updating",
  Upload = "upload",
  UserAlt = "user-alt",
  UserGroup = "user-group",
  User = "user",
  Videocam = "videocam",
  ViewDetails = "view-details",
  VpnKey = "vpn-key",
  WarningFilled = "warning-filled",
  WarningLine = "warning-line",
  Warning = "warning",
  WelcomeLetter = "welcome-letter",
  WhatsappFilled = "whatsapp-filled",
  Whatsapp = "whatsapp",
}
export default PebbleIcon;
